
import { InputCheckboxGroup, type CheckboxOptionType } from "@/components/input-checkbox-group";
import { InputText } from "@/components/input-text";
import Modal from "@/components/modal/Modal";
import { useState } from "react";
import "./export-data.css"
import { Checkbox } from "@/components/checkbox";

interface ExportDataProps {
    isOpen: boolean;
    options: CheckboxOptionType[];
    tags: boolean;
    onCancel: () => void;
    onExport: (columns: string[], name?: string, exportSelection?: boolean) => void;
}

export const ExportData = ({isOpen=false, options, tags, onCancel, onExport}: ExportDataProps) => {

    const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
    const [exportSelection, setExportSelection] = useState<boolean>(true);
    const [name, setName] = useState("")

    return (
        <Modal 
            cancelText="Annuler"
            confirmText="Exporter"
            isOpen={isOpen}
            title="Exporter les données"
            onCancel={() => {
                setSelectedCategories([]);
                setExportSelection(true);
                onCancel()}}
            onConfirm={() => {
                onExport(selectedCategories, name, exportSelection);
                setSelectedCategories([]);
                setExportSelection(true);
            }}
        >
            <form className="export-data-form">
                <InputText 
                    className="export-data-text-input" 
                    name="title" label="Nom du rapport" 
                    placeholder="Nom du rapport"
                    onChange={(e) =>
                        setName(e.target.value)
                    }/>
                <InputCheckboxGroup 
                    label="Catégories à exporter" 
                    options={options} 
                    value={selectedCategories}
                    onChange={setSelectedCategories}
                />
                {tags && <Checkbox
                    id="export-selection"
                    label="Exporter seulement la sélection ?" 
                    checked={exportSelection}
                    onChange={(checked) => setExportSelection(checked)}
                />}
            </form>
        </Modal>
)};